import { createRideDataStore } from "@be-miniapp/shared/stores"
import type { CurrentRideData, RideLocation } from "@be-miniapp/shared/stores"

import { useUserStore } from "./user-session"

const useRideDataStore = createRideDataStore({
  getUserLocation: () => useUserStore.getState().location,
  allowUndefinedDropoffLocation: true,
  resetBehavior: "merge",
})

export { useRideDataStore }
export type { CurrentRideData, RideLocation }
